module.exports = new __parcel__URL__("about.eaf6eac9.png").toString();